import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig"; // Firebase config
import { collection, getDocs, query, where } from "firebase/firestore";
import './display.css';
import { Pie } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from "chart.js";
import './display.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const Partnership = () => {
    const [transactions, setTransactions] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [netProfit, setNetProfit] = useState(0);
    const [selectedPartner, setSelectedPartner] = useState("all");

    const uniquePartners = [
        ...new Set(transactions.map((tx) => tx.partner || "Personal")),
    ];

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "transactions"));
                const fetchedTransactions = [];

                querySnapshot.forEach((doc) => {
                    fetchedTransactions.push({ ...doc.data(), id: doc.id });
                });

                setTransactions(fetchedTransactions);
            } catch (error) {
                console.error("Error fetching transactions: ", error);
            }
        };

        fetchTransactions();
    }, []);
    const filterTransactionsByDate = () => {
        let filtered = transactions;

        // ✅ Filter by partner FIRST
        if (selectedPartner !== "all") {
            filtered = filtered.filter(
                (tx) => (tx.partner || "Personal") === selectedPartner
            );
        }

        // ✅ Then filter by date (existing logic)
        if (!startDate || !endDate) return filtered;

        const start = new Date(startDate);
        const end = new Date(endDate);

        return filtered.filter(tx => {
            const txDate = new Date(tx.date);
            return txDate >= start && txDate <= end;
        });
    };
    const calculateNetProfit = () => {
        const filteredTxns = filterTransactionsByDate();

        const scripMap = {};

        filteredTxns.forEach(tx => {
            const { scrip, transactionType, quantity, rate } = tx;

            const shareAmount = quantity * rate;
            const commission = shareAmount * 0.0036;

            if (!scripMap[scrip]) {
                scripMap[scrip] = {
                    buyQty: 0,
                    sellQty: 0,
                    buyAmount: 0,
                    sellAmount: 0
                };
            }

            if (transactionType === "BUY") {
                scripMap[scrip].buyQty += Number(quantity);
                // ✅ Add commission to buy
                scripMap[scrip].buyAmount += shareAmount + commission;
            } else {
                scripMap[scrip].sellQty += Number(quantity);
                // ✅ Deduct commission from sell
                scripMap[scrip].sellAmount += shareAmount - commission;
            }
        });

        let grossProfit = 0;

        Object.keys(scripMap).forEach(scrip => {
            const stock = scripMap[scrip];

            // only completed trades
            if (stock.buyQty === stock.sellQty) {
                grossProfit += stock.sellAmount - stock.buyAmount;
            }
        });

        // ✅ Capital gain (7.5%)
        const capitalGain = grossProfit > 0 ? grossProfit * 0.075 : 0;

        const finalNetProfit = grossProfit - capitalGain;

        setNetProfit(finalNetProfit);
    };

    const getPieData = () => {
        // ✅ If PERSONAL selected → 100% to Chandan
        if (selectedPartner === "Personal") {
            return {
                labels: ["Chandan"],
                datasets: [
                    {
                        label: "Profit Sharing",
                        data: [netProfit],
                        backgroundColor: ["#36A2EB"],
                    }
                ]
            };
        }

        // ✅ If specific partner selected (not all)
        if (selectedPartner !== "all") {
            return {
                labels: ["Chandan (40%)", `${selectedPartner} (60%)`],
                datasets: [
                    {
                        label: "Profit Sharing",
                        data: [netProfit * 0.4, netProfit * 0.6],
                        backgroundColor: ["#36A2EB", "#FF6384"],
                    }
                ]
            };
        }

        // ✅ If ALL selected → treat like partnership (optional behavior)
        return {
            labels: ["Chandan (50%)", "Partner (50%)"],
            datasets: [
                {
                    label: "Profit Sharing",
                    data: [netProfit * 0.5, netProfit * 0.5],
                    backgroundColor: ["#36A2EB", "#FF6384"],
                }
            ]
        };
    };

    return (
        <div className="container">
            <h1>Scheme: Profit Sharing</h1>

            <div className="filter-container">
                <label>
                    Start Date:
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </label>
                <label>
                    End Date:
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </label>
                <label>
                    Filter by Partner:
                    <select
                        value={selectedPartner}
                        onChange={(e) => setSelectedPartner(e.target.value)}
                    >
                        <option value="all">All</option>
                        {uniquePartners.map((p) => (
                            <option key={p} value={p}>{p}</option>
                        ))}
                    </select>
                </label>
                <button onClick={calculateNetProfit}>Show Profit</button>
            </div>

            <div className="statistics-container">
                <div className="stat-card">
                    <h2>Total Realized Profit</h2>
                    <p>{netProfit.toFixed(2)}</p>
                </div>
            </div>

            <div className="chart-container" style={{ maxWidth: "500px", margin: "auto" }}>
                <Pie data={getPieData()} />
            </div>
        </div>
    );
};

export default Partnership;